// extracted by mini-css-extract-plugin
export default {"container":"lNOs9W","component":"sBvY_G","content":"iEwXqj","active":"OjcEHk","inline":"fEPUYB","tab":"YYTBs6"};